import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { useAllBadgeList } from '../../hooks';
import { Virtuoso } from 'react-virtuoso';
import { BadgeAvatar } from '@/components';
import { useHistory } from 'react-router-dom';

import styles from './index.module.scss';
import { OfficialBadge } from '../../types';

export const ListContainer = () => {
  const { t } = useTranslation();

  const { data } = useAllBadgeList();
  const history = useHistory();
  const itemContent = useCallback(
    (_, item) => {
      const isOfficialBadge = (item as OfficialBadge)?.official_id;
      return (
        <div
          className={styles.item}
          onClick={() =>
            item?.id && history.push(`/${isOfficialBadge ? 'official-badge' : 'badge'}/${item?.id}`)
          }>
          <BadgeAvatar src={item.logo_thumbnail_url} width={38} className={styles.badgeIcon} />
          <div className={styles.nameContainer}>
            <div className={styles.name}>{item.name}</div>
            {isOfficialBadge && (
              <span className={styles.issuedBy}>
                {t('ListContainer.328ycs')}
                {(item as OfficialBadge)?.official?.name}
              </span>
            )}
          </div>
        </div>
      );
    },
    [history, t],
  );

  return (
    <>
      <div className={styles.listHeader}>
        <span className={styles.title}>{t('ListContainer.122hkz')}</span>
        <span>{t('ListContainer.1fvl7')}</span>
      </div>
      <div className={styles.listContainer}>
        <Virtuoso useWindowScroll data={data} overscan={10} itemContent={itemContent} />
      </div>
    </>
  );
};
